import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ButtonModule } from '../button/index';
import { GenericModule } from '../generic/index';
import { IconModule } from '../icon/index';
import { MediaModule } from '../media/index';

import { DrawerRefBase, DrawerParamsBase } from './drawer.base';
import { DrawerService, DrawerRef, DrawerParams } from './drawer.service';

import { DrawerWrapperComponent } from './components/wrapper/wrapper.component';
import { DrawerComponent } from './components/drawer/drawer.component';

import { DrawerHeaderComponent } from './components/partials/header/header.component';
import { DrawerTitleComponent, DrawerHeadingTitleComponent } from './components/partials/title/title.component';
import { DrawerSubtitleComponent, DrawerHeadingSubtitleComponent } from './components/partials/subtitle/subtitle.component';
import { DrawerCloseComponent, DrawerCloseDirective } from './components/partials/close/close.component';
import { DrawerDismissComponent, DrawerDismissDirective } from './components/partials/dismiss/dismiss.component';
import { DrawerContentComponent } from './components/partials/content/content.component';
import { DrawerBodyComponent } from './components/partials/body/body.component';
import { DrawerFooterComponent } from './components/partials/footer/footer.component';

export { DrawerRefBase, DrawerParamsBase } from './drawer.base';
export { DrawerService, Drawer, DrawerRef, DrawerParams } from './drawer.service';

export { DrawerWrapperComponent } from './components/wrapper/wrapper.component';
export { DrawerComponent } from './components/drawer/drawer.component';

export { DrawerHeaderComponent } from './components/partials/header/header.component';
export { DrawerTitleComponent, DrawerHeadingTitleComponent } from './components/partials/title/title.component';
export { DrawerSubtitleComponent, DrawerHeadingSubtitleComponent } from './components/partials/subtitle/subtitle.component';
export { DrawerCloseComponent, DrawerCloseDirective } from './components/partials/close/close.component';
export { DrawerDismissComponent, DrawerDismissDirective } from './components/partials/dismiss/dismiss.component';
export { DrawerContentComponent } from './components/partials/content/content.component';
export { DrawerBodyComponent } from './components/partials/body/body.component';
export { DrawerFooterComponent } from './components/partials/footer/footer.component';

@NgModule({
  declarations: [
    DrawerComponent,

    DrawerWrapperComponent,

    DrawerHeaderComponent,
    DrawerTitleComponent,
    DrawerHeadingTitleComponent,
    DrawerSubtitleComponent,
    DrawerHeadingSubtitleComponent,
    DrawerCloseComponent,
    DrawerDismissComponent,
    DrawerDismissDirective,
    DrawerCloseDirective,
    DrawerContentComponent,
    DrawerBodyComponent,
    DrawerFooterComponent
  ],
  entryComponents: [
    DrawerComponent
  ],
  imports: [
    CommonModule,

    ButtonModule,
    GenericModule,
    IconModule,
    MediaModule
  ],
  exports: [
    DrawerWrapperComponent,

    DrawerHeaderComponent,
    DrawerTitleComponent,
    DrawerHeadingTitleComponent,
    DrawerSubtitleComponent,
    DrawerHeadingSubtitleComponent,
    DrawerCloseComponent,
    DrawerDismissComponent,
    DrawerDismissDirective,
    DrawerCloseDirective,
    DrawerContentComponent,
    DrawerBodyComponent,
    DrawerFooterComponent
  ],
  providers: [
    DrawerService,

    DrawerRefBase,
    DrawerParamsBase,

    DrawerRef,
    DrawerParams
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class DrawerModule {}
